import { render, staticRenderFns } from "./PageMeasurements.vue?vue&type=template&id=536b0b0e"
import script from "./PageMeasurements.vue?vue&type=script&lang=js"
export * from "./PageMeasurements.vue?vue&type=script&lang=js"
import style0 from "./PageMeasurements.vue?vue&type=style&index=0&id=536b0b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports